import styled from "styled-components";
import { pxToRem } from "styles/utils";

export const Container = styled.div`
  position: relative;
  display: inline-block;
  width: 100%;
`;

interface TooltipWrapperProps {
  top: number;
  left: number;
}

export const TooltipWrapper = styled.div<TooltipWrapperProps>`
  position: fixed;
  /*
    Настоящие экранные пиксели, а не rem: значения приходят из
    getBoundingClientRect и уже посчитаны в координатах окна.
    Перевод в rem сдвинул бы подсказку мимо элемента.
  */
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;

  border: ${pxToRem(1)} solid ${({ theme }) => theme.colors.grayLine};
  padding: ${({ theme }) => pxToRem(theme.spacing.lg)};
  z-index: 1000;
  width: ${pxToRem(329)};
  word-wrap: break-word;

  border-radius: ${({ theme }) => pxToRem(theme.radii.lg)}
    ${({ theme }) => pxToRem(theme.radii.lg)}
    ${({ theme }) => pxToRem(theme.radii.lg)} 0;
  box-shadow: ${({ theme }) => theme.shadows.md}, ${({ theme }) => theme.shadows.ring};
  background: ${({ theme }) => theme.colors.white};

  font-size: ${({ theme }) => pxToRem(theme.fontSize.sm)};
  font-weight: 500;
  color: ${({ theme }) => theme.colors.ink};

  a {
    color: ${({ theme }) => theme.colors.brand};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }

    &:focus-visible {
      outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
      outline-offset: ${pxToRem(2)};
      border-radius: ${({ theme }) => pxToRem(theme.radii.sm)};
    }
  }
`;
